import { render, staticRenderFns } from "./Help.vue?vue&type=template&id=76f55692&scoped=true&"
import script from "./Help.vue?vue&type=script&lang=ts&"
export * from "./Help.vue?vue&type=script&lang=ts&"
import style0 from "./Help.vue?vue&type=style&index=0&id=76f55692&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f55692",
  null
  
)

export default component.exports